module.exports = __webpack_public_path__ + "media/images/emoticons/crying-7606f12b557b0e8e59d033e1edebba6d.gif";